// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetProperty = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        property: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getPropertyHandler: async function() {

            try {

                propertiesModel.doc(this.$route.params.id).get()
                .then(doc => {

                    if (!doc.exists) return;

                    /*
                    **  Check if owned by user
                    */
                    
					if (this.user.id == doc.data().relationships.user) {

                        /*
                        **  Set the prop
                        **  @prop: @here
                        */

						this.property = doc.data();

					} else {
 
                        /*
                        **  Notify the user
                        **  @service: @SweetAlert2
                        */

						this.$swal('Uh Oh!', 'Looks like you don\'t have the necessary permissions to view this property.', 'error');

                        /*
                        **  Redirect user to properties dashboard page
                        **  @service: @Vue
                        */

						this.$router.push({ name: 'PropertiesDashboard' });

					}

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get the Property from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Property',
                        uid: 'm4sQNEm3yDcPP3V2FeNp',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Perform the Query to Get the Property Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Property',
                    uid: 'w4yT8kKpTxaosRsCZMsK',
                    error: e
                });

            }

        }

    }

}